import React from "react";
import { observer } from "mobx-react";
import { PillarModel, PillarArticleModel } from "../../models/PillarModel";
import StoriesStore from "../../stores/StoriesStore";
import PillarArticle from "./PillarArticle";
import { ContentImagePath } from "../../utils/ContentMediaPath";
import { scrollTo } from "../../utils/scrollTo";
import slice from "lodash/slice";

interface PillarItemProps {
  pillar: PillarModel;
  store: StoriesStore;
  history: any;
}

interface PillarItemState {
  currentArticlePage: number;
}

@observer
export default class PillarItem extends React.Component<PillarItemProps, PillarItemState> {
  articlesPerPage: number = 5;
  startScrollPosition: number = null;

  constructor(props: PillarItemProps) {
    super(props);

    this.state = {
      currentArticlePage: 1
    };

    this.selectPillar = this.selectPillar.bind(this);
    this.deselectPillar = this.deselectPillar.bind(this);
    this.paginateArticles = this.paginateArticles.bind(this);
    this.showNextPage = this.showNextPage.bind(this);
    this.dismissScrollHint = this.dismissScrollHint.bind(this);
  }

  selectPillar(e): void {
    e.preventDefault();
    const { pillar, store } = this.props;

    if (!store.isPillarSelected(pillar)) {
      store.selectPillar(pillar);
      this.props.history.push(`/${pillar.url}`);
    }

    if (store.breakpoint.isMobile) {
      setTimeout(() => {
        scrollTo(this.startScrollPosition, 500);
      });
    }
  }

  deselectPillar(e): void {
    e.preventDefault();
    this.props.store.deselectPillar();
    this.props.history.push("/");
  }

  paginateArticles() {
    const { currentArticlePage } = this.state;
    const { selectedPillarArticles } = this.props.store;
    let amountToShow = this.articlesPerPage * currentArticlePage;

    return slice(selectedPillarArticles, 0, amountToShow);
  }

  showNextPage() {
    let currentArticlePage = this.state.currentArticlePage + 1;
    this.setState({ currentArticlePage });
  }

  componentDidMount() {
    const { id } = this.props.pillar;

    setTimeout(() => {
      this.startScrollPosition = document.getElementById(`pillar__item-${id.toString()}`).offsetTop;
    }, 100);
  }

  dismissScrollHint() {
    this.props.store.dismissScrollHint(true);
  }

  render() {
    const { currentArticlePage } = this.state;
    const { pillar, store } = this.props;
    const {
      isAnyPillarSelected,
      selectedPillar,
      selectedPillarArticles,
      breakpoint,
      isPillarSelected,
      isScrollHintDismissed,
      dismissScrollHint
    } = store;
    const isActive = isPillarSelected(pillar);
    let articles = [];
    let delayIncrementer = 0;

    if (isAnyPillarSelected) {
      articles = breakpoint.isMobile ? this.paginateArticles() : selectedPillarArticles; //only limit on mobile
      dismissScrollHint();
    }

    const summaryBg =
      breakpoint.isMobile && pillar.menuImageMobi ? pillar.menuImageMobi : pillar.menuImage;
    const fullBg =
      breakpoint.isMobile && pillar.menuImageMobi ? pillar.menuImageMobi : pillar.fullImage;

    return (
      <section
        id={`pillar__item-${pillar.id.toString()}`}
        className={`pillars__item ${
          isAnyPillarSelected && isActive ? "pillars__item--active" : ""
        } ${isAnyPillarSelected && !isActive ? "pillars__item--collapsed" : ""}`}
        style={{ backgroundColor: pillar.color }}
      >
        <div
          className={`pillars__bg ${isActive ? "" : "pillars__bg--hidden"}`}
          style={{ backgroundImage: `url("${ContentImagePath(fullBg)}")` }}
        />

        {isActive && <div className="pillars__close" onClick={this.deselectPillar} />}

        {!isActive && (
          <div className="pillars__label" onClick={this.selectPillar}>
            <div className="pillars__labelOverlay" />
            <div className="pillars__labelText">{pillar.title}</div>
          </div>
        )}

        {!isActive && (
          <div className="pillars__summary" onClick={this.selectPillar}>
            <div
              className="pillars__summaryBg"
              style={{ backgroundImage: `url("${ContentImagePath(summaryBg)}")` }}
            />

            <div className="pillars__summaryInner">
              <h1 className="pillars__summaryTitle">{pillar.quote}</h1>
              <div className="pillars__btnExpand">{pillar.title}</div>
            </div>
          </div>
        )}

        <div className="pillars__content">
          <div className="pillars__text">
            {isActive && (
              <div className="pillars__textContent">
                <div
                  className="pillars__header"
                  style={{ backgroundImage: `url("${ContentImagePath(fullBg)}")` }}
                >
                  <div className="pillars__contentQuote" style={{ color: pillar.color }}>
                    {pillar.quote}
                  </div>
                  <h1 className="pillars__title">{pillar.title}</h1>
                </div>
                <div className="pillars__copy">
                  <p>{pillar.introText}</p>
                  <p>
                    <a className="btn" href="/configure">
                      Build and Buy your XV
                    </a>
                  </p>
                </div>
              </div>
            )}
          </div>

          <div className="pillars__articles">
            {isActive && (
              <div className="pillars__scroll">
                {selectedPillar &&
                  articles.map((article, i) => {
                    let isFirstPage = currentArticlePage === 1;
                    if (i >= (currentArticlePage - 1) * this.articlesPerPage) {
                      delayIncrementer += 100;
                    }

                    return (
                      <PillarArticle
                        key={`pillarArticle-${i}`}
                        article={article}
                        animationDelay={delayIncrementer}
                        isFirstPage={isFirstPage}
                      />
                    );
                  })}
                {articles.length < selectedPillarArticles.length && (
                  <div className="pillars__loadMore">
                    <a className="btn btn--secondary" onClick={this.showNextPage}>
                      Load more
                    </a>
                  </div>
                )}
              </div>
            )}
            <div
              className={`pillars__scrollHint ${isActive ? "pillars__scrollHint--animate" : ""} ${
                isScrollHintDismissed ? "pillars__scrollHint--dismissed" : ""
              }`}
              onClick={this.dismissScrollHint}
            />
          </div>
        </div>
      </section>
    );
  }
}
